import { Box, Button, Group, Space, Stack, Text } from '@mantine/core';
import Image from 'next/image';
import { VespaLogoBlack } from '@vespaai/assets';
import { CookiePreferences } from 'app/lib/features/osano/cookie-preferences';
import { Auth } from 'app/lib/auth/auth-paths';
import { useConfigSystem } from 'app/queries/config/use-config-system';
import { getRedirectUrl } from 'app/lib/auth/login-redirect';
import classNames from 'app/components/homepage.module.css';
import type { ReactNode } from 'react';

function GetStarted({ loading }: { loading: boolean }): ReactNode {
  const { isPublic } = useConfigSystem();

  return (
    <Group gap="md" align="center">
      {isPublic && (
        <Button
          component="a"
          className={classNames.getStarted}
          classNames={{ label: classNames.buttonLabel }}
          style={loading ? { pointerEvents: 'none', opacity: 0.89 } : {}}
          data-testid={loading ? 'signup-loading' : 'signup-loaded'}
          href={Auth.signup}
          loading={loading}
          variant="filled"
          color="dark"
        >
          Sign up for free
        </Button>
      )}
      <Button
        component="a"
        className={classNames.getStarted}
        style={loading ? { pointerEvents: 'none', opacity: 0.89 } : {}}
        data-testid={loading ? 'loading' : 'loaded'}
        href={isPublic ? Auth.login : getRedirectUrl()}
        loading={loading}
        bg="white"
        variant="filled"
      >
        Login
      </Button>
    </Group>
  );
}

export function Homepage({ loading }: { loading: boolean }): ReactNode {
  return (
    <Stack className={classNames.container} align="center">
      <Box className={classNames.floatLayer} aria-hidden="true">
        {/* Single decorative diagonal line at 45deg across the screen */}
        <Box className={`${classNames.line} ${classNames.diagLineLeft}`} />
        <Box className={`${classNames.line} ${classNames.horzLineTop}`} />
        <Box className={`${classNames.line} ${classNames.diagLineRight}`} />
        <Box className={`${classNames.line}  ${classNames.horzLineBottom}`} />
      </Box>
      <Stack align="center" gap="xl" style={{ position: 'relative', zIndex: 1 }}>
        <Stack align="center" gap="xl">
          <Image
            src={VespaLogoBlack}
            width={505}
            height={119}
            style={{ maxWidth: '90vw' }}
            alt="Vespa.ai"
            priority
          />
          <Stack align="center" gap="sm">
            <Text className={classNames.subTitle} c="black" w={600} maw={'95vw'}>
              Vespa is the AI Search Platform for building enterprise grade RAG, Search and
              Recommendation systems
            </Text>
          </Stack>
        </Stack>
        <GetStarted loading={loading} />
        <Space h={110} />
      </Stack>
      <Box
        style={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          width: '100%',
          zIndex: 1000,
          padding: '1rem',
          color: '#fff',
        }}
      >
        <CookiePreferences />
      </Box>
    </Stack>
  );
}
